/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth



(function ($) {
  Drupal.behaviors.special = {
    attach: function (context) {
      'use strict';

      /**
       * Slider Bg
       */
      $('.paragraph--type-slideshow .field--name-field-image').once().each(function () {
        $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      });

      /**
       * Menu Acccessibility
       */
      $(document.body).on('mouseenter focus', '.main-menu__item--with-sub > a', function (e) {
        // Show sub-menu
        $('.main-menu--sub').css({
          'visibility': 'visible',
          'opacity': '1'
        });
      }).on('mouseleave blur', '.main-menu--sub  .main-menu__item--sub-1:last-child a', function (e) {
        $('.main-menu--sub').css({
          'visibility': 'hidden',
          'opacity': '0'
        });
      });

      $('nav ul.menu a').click(function () {
        var gettxt = $(this).text().trim();
        gtag('event', 'Scroll', {
          'event_category': 'Hompage Navigation',
          'event_label': gettxt,
          'value': '1'
        });
      });

      $('.js-pager__items a').click(function () {
        var gettxt = window.location.pathname.trim();

        if (gettxt == '/') {
          gtag('event', 'Load more', {
            'event_category': 'Navigation',
            'event_label': 'Home Page',
            'value': '1'
          });
        } else {
          gtag('event', 'Load more', {
            'event_category': 'Navigation',
            'event_label': gettxt.replace('/', ''),
            'value': '1'
          });
        }

      })

    }
  }

})(jQuery);
